import { Component, OnInit } from '@angular/core';
import { API } from '../../_config/strings';

@Component({
  selector: 'app-ayuda',
  templateUrl: './ayuda.component.html',
  styleUrls: ['./ayuda.component.scss']
})
export class AyudaComponent implements OnInit {
API:any;
  constructor() {
    this.API = API;
   }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/ayuda/ayuda.component.ts